module.exports = __webpack_public_path__ + "img/sseating.b590b2d3.png";